"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.natalie.description': 'Przyjazna, inteligentna Amerykanka idealna do narracji.',
};
